import { render } from "./EditCanvas.vue?vue&type=template&id=837c7f36"
import script from "./EditCanvas.vue?vue&type=script&lang=js"
export * from "./EditCanvas.vue?vue&type=script&lang=js"

import "./EditCanvas.vue?vue&type=style&index=0&id=837c7f36&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__